import { CSSObject } from "@emotion/react";
import { mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: breakpoints } = mediaQueryStyles;

export const imageWrapperStyles: CSSObject = {
  position: "relative",
  "z-index": 2,
};

export const imageWrapperWithTranslateStyles: CSSObject = {
  position: "relative",
  "z-index": 2,
  [breakpoints.upTo("sm")]: {
    paddingInlineStart: "40px",
  },
};
